module.exports = __webpack_public_path__ + "static/media/logo_main.19f6ee3c.svg";